import React from "react";
import "./uiInput.css"

type InputProps = {
    className?: string,
    icon?: string,
    iconFunction?: (inputContent: string) => void,
    onChange?: (event: React.FormEvent<HTMLInputElement>) => void,
    placeholder?: string,
    disabled?: boolean,
    defaultValue?: string,
    hideText?: boolean,
    clearInputAfterIconClick?: boolean,
    enterKeyTriggerIconFunction?: boolean,
    enterKeyTriggerBlurInput?: boolean,
    isOnError?: boolean,
    onSubmit?: (event: React.FormEvent<HTMLInputElement>) => void,
    name?: string
}

export const UiInput: React.FC<InputProps> = (
    {
        className = "",
        icon = undefined,
        iconFunction = undefined,
        placeholder = undefined,
        onChange = undefined,
        disabled = false,
        defaultValue = "",
        hideText = false,
        clearInputAfterIconClick = false,
        enterKeyTriggerIconFunction = false,
        enterKeyTriggerBlurInput = false,
        isOnError = false,
        onSubmit = undefined,
        name
    }) => {
    const [inputContent, setInputContent] = React.useState(defaultValue)
    
    function startIconFunction() {
        if (iconFunction !== undefined) {
            if (clearInputAfterIconClick) {
                setInputContent("")
            }

            iconFunction(inputContent)
        }
    }
    
    return (
        <div className={
                className + " ui-input bg-deep-blue  border-2 " +
                (icon !== undefined ? " ui-input-icon flex justify-between pr-2" : "p-0") +
                (isOnError ? " border-red-500" : " border-darkpurple-blue")
        }>
            <input
                className={
                    "bg-deep-blue w-full " +
                    (disabled ? " cursor-not-allowed text-disabled" : "")
                }
                placeholder={placeholder}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        if (enterKeyTriggerIconFunction) {
                            if (enterKeyTriggerBlurInput) {
                                (e.target as HTMLInputElement).blur();
                            }
                            startIconFunction();
                        }
                        
                        if (onSubmit) {
                            onSubmit(e)
                        }
                    }
                }}
                onInput={(e) => {
                    const value = (e.target as HTMLInputElement).value
                    setInputContent(value)
                    if (onChange) {
                        onChange(e)
                    }
                }}
                value={inputContent}
                disabled={disabled}
                type={hideText ? "password" : "text"}
                name={name ? name: ""}
            />
            
            {icon &&
                <div className="flex justify-center items-center h-full py-2.5">
                    <button
                        className="ui-input-icon-div flex items-center
                            justify-center bg-purple-blue hover:bg-darkpurple-blue cursor-pointer min-h-8 min-w-8
                             aspect-square h-full w-auto"
                        onClick={startIconFunction}
                    >
                        <img
                            className="h-1/2 aspect-square"
                            src={`icons/${icon}.svg`}
                            alt=""
                        />
                    </button>
                </div>
            }
        </div>
    )
}
